export default {
      id: "icon-close-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-close",
      toString: function () {
        return this.url;
      }
    }